import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import { TEAL, TEAL_DARK } from "../constants";
 
export const BootstrapButton = styled(Button)({
  boxShadow: "none", textTransform: "none", fontSize: 14, color: "#fff",
  padding: "5px 10px", border: "1px solid", lineHeight: 1.5,
  backgroundColor: TEAL, fontFamily: "Roboto, sans-serif",
  "&:hover": { backgroundColor: TEAL_DARK, boxShadow: "none" },
  "&:active": { boxShadow: "none" },
  "&:focus": { boxShadow: "0 0 0 0.2rem rgba(6,157,174,.3)" },
});
 